<div class="bg-white">
    <h3 class="settings-header px-4 py-3 mb-2 mb-md-5">
        {{'filters_settings' | translate}}
        <small>- {{'filters_settings_desc' | translate}}
            <a href="https://help.teammood.com/en/articles/5985050-custom-filters" target="_blank" class="help" title="{{'filters_help_link' | translate}}"><i class="far fa-question-circle"></i></a>
        </small>
    </h3>
    
    <div class="settings-sub-header w-100 p-2">
        <div class="col-md-10 mx-auto d-md-flex justify-content-between">
            <div>
                <h4>{{ 'filters_subtitle_settings' | translate}}</h4>
                <h4>
                    <small>{{'filters_subtitle_settings_desc_1' | translate}}</small>
                </h4>
            </div>
            <div>
                <button type="button" class="btn btn-primary" (click)="addFilter()"> {{'filters_setting.new' | translate}}</button>
            </div>
        </div>
    </div>
    
    <div class="row bg-grey filter-table g-0 pt-4">
        <div class="col-md-10 mx-auto">
            <div class="panel panel-default">
                <div class="panel-heading"><i class="far fa-filter"></i> {{'filters_setting.pre_defined_filter_title' | translate}}</div>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">{{'filters_setting.name' | translate}}</th>
                            <th scope="col">{{'filters_setting.type' | translate}}</th>
                            <th scope="col" class="text-center"></th>
                            <th scope="col" class="text-center">{{'filters_setting.duplicate' | translate}}</th>
                            <th scope="col" class="text-center"></th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
    
                    <tbody>
                        @for(namedFilter of namedFilters; track namedFilter.id){
                            @if(namedFilter.baseNamedFilter){
                                <tr>
                                    <td>{{namedFilter.name}}</td>
                                    <td><i>{{namedFilter.type}}</i></td>
                                    <td class="text-center">
                                    </td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-secondary" (click)="duplicate(namedFilter.id)" title="{{'digests_setting.actions.duplicate_desc' | translate}}"><i class="far fa-copy"></i>
                                        </button>
                                    </td>
                                    <td class="text-center">
                                    </td>
                                    <td [ngClass]="{defaultNamedFilter: namedFilter.default}">
                                        @if(namedFilter.default){
                                            <span class="default-namedFilter">{{'filters_setting.default' | translate}}</span>
                                        }
                                        @else {
                                            <a (click)="setAsDefault(namedFilter.id)" class="set-default-namedFilter">{{'filters_setting.set_as_default' | translate}}</a>
                                        }
                                    </td>
                                </tr>
                            }
                        } 
                    </tbody>
                </table>
            </div>
    
            <div class="panel panel-default">
                <div class="panel-heading"><i class="far fa-plus"></i><i class="far fa-filter"></i> {{'filters_setting.advanced_filter_title' | translate}}</div>
                @if(customFilters?.length === 0){
                    <div class="panel-body p-3">
                        <p>{{'filters_setting.no_filters' | translate}}</p>
                        <button type="button" class="btn btn-primary mt-1" (click)="addFilter()"> {{'filters_setting.new' | translate}}</button>
                    </div>
                }
    
                @if(customFilters?.length > 0){
                    <table class="table table-hover">
                        <thead>
                            <tr><th scope="col">{{'filters_setting.name' | translate}}</th>
                            <th scope="col">{{'filters_setting.combination' | translate}}</th>
                            <th scope="col" class="text-center">{{'filters_setting.update' | translate}} / {{'filters_setting.duplicate' | translate}} / {{'filters_setting.delete' | translate}}</th>
                            <th scope="col"></th>
                        </tr></thead>
        
                        <tbody>
                            @for (namedFilter of customFilters; track namedFilter.id) {
                                <tr>
                                    <td>{{namedFilter.name}}</td>
                                    <td>{{namedFilter.filterTitle}}</td>
                                    <td class="text-center">
                                        <button type="button" [disabled]="namedFilter.baseNamedFilter" class="btn btn-secondary btn-action" (click)="updateFilter(namedFilter)" title="{{'digests_setting.actions.update_desc' | translate}}"><i class="far fa-pen"></i>
                                        </button>
                                        <button type="button" class="btn btn-secondary btn-action" (click)="duplicate(namedFilter.id)" title="{{'digests_setting.actions.duplicate_desc' | translate}}"><i class="far fa-copy"></i>
                                        </button>
                                        <button type="button" [disabled]="namedFilter.baseNamedFilter" class="btn btn-danger btn-action" (click)="remove(namedFilter.id)" title="{{'digests_setting.delete_desc' | translate}}"><i class="far fa-trash-alt"></i>
                                        </button>
                                    </td>
                                    <td [ngClass]="{defaultNamedFilter: namedFilter.default}">
                                        @if(namedFilter.default){
                                            <span class="default-namedFilter">{{'filters_setting.default' | translate}}</span>
                                        }
                                        @else {
                                            <a (click)="setAsDefault(namedFilter.id)" class="set-default-namedFilter">{{'filters_setting.set_as_default' | translate}}</a>
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }
            </div>
        </div>
    </div>
</div>

